var PaymentService = (function ($, _, Backbone, PromiseUtil) {

	// TBD: why we're using model?
	// TBD: pipe() method is obsoleted, use then()
	var PaymentService = Backbone.Model.extend({
		initialize: function (attrs, opts) {
			if (!opts.paymentStrategy) {
				throw new Error('You must define opts.paymentStrategy to use payment service!');
			}
			this._paymentStrategy = opts.paymentStrategy;
		},

		pay: function (provider, method) {
			return this._paymentStrategy.beforeProcess(method)
                       .pipe(_.bind(this._process, this, provider))
					   .pipe(_.bind(this._paymentStrategy.betweenProcessAndComplete, this._paymentStrategy))
                       .pipe(_.bind(this._complete, this, provider))
					   .pipe(_.bind(this._paymentStrategy.afterComplete, this._paymentStrategy))
                       .promise();
		},

		// TBD: only for compatibility, can be removed after views refactoring
		useMethod: function (provider, method) {
			return this.pay(provider, method);
		},

		tryComplete: function (provider, data) {
			return provider.tryComplete(data).done(_.bind(this._paymentStrategy.afterTryComplete, this._paymentStrategy));
		},

		_process: function (provider, method) {
			return method && ( method.Token || method.Nonce ) ? PromiseUtil.resolved(method) : provider.prepayment();
		},

		_complete: function (provider, data) {
			return provider.complete(data);
		}
	});

	return PaymentService;
})($, _, Backbone, PromiseUtil);
